import Styles from './BlazeRecommendationsRow.module.scss'
import { useImageMenuContext } from '../ImageMenuContext'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Carousel } from 'components/Carousel/Carousel'
import { Button } from 'blaze-ui/Button'
import { SelectableFile } from '../SelectableFile/SelectableFile'
import { useBlazeRecommendations } from '../BlazeRecommendations/useBlazeRecommendations'
import { useBlazeImageSelection } from '../BlazeRecommendations/useBlazeImageSelection'
import { GeneratingRecommendation } from '../BlazeRecommendations/GeneratingRecommendation'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

const BlazeRecommendationsRowContent = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { setProvider } = useImageMenuContext()
  const { toggle, isSelected } = useBlazeImageSelection()
  const { recommendations, updateRecommendation, removeRecommendation, brandProfileId } = useBlazeRecommendations()

  if (!brandProfileId) return null

  return (
    <div className={Styles.container}>
      <div className={Styles.rowHeader}>
        <Heading level={isSystemRedesignEnabled ? 5 : 4} color="var(--dark-80)">
          Blaze recommendations
        </Heading>
        <Button size="sm" variant="ghost" onPress={() => setProvider('blazeRecommendations')}>
          See All
        </Button>
      </div>
      <div className={Styles.carouselContainer}>
        <Carousel offset={20}>
          {recommendations.map((rec) => {
            if (rec.type === 'placeholder') {
              return (
                <GeneratingRecommendation
                  key={rec.id}
                  id={rec.id}
                  brandProfileId={brandProfileId}
                  onSuccess={updateRecommendation}
                  onError={removeRecommendation}
                />
              )
            }
            if (!rec.image) return null
            const image = rec.image
            return (
              <SelectableFile key={rec.id} onSelect={() => toggle(image)} isSelected={isSelected(image.url)}>
                <img src={image.url} alt="" />
              </SelectableFile>
            )
          })}
        </Carousel>
      </div>
    </div>
  )
}

export const BlazeRecommendationsRow = () => {
  const { hiddenProviders } = useImageMenuContext()

  if (hiddenProviders.includes('blazeRecommendations')) return null

  return <BlazeRecommendationsRowContent />
}
